import type { TailoredResume } from "./renderer";
import sample from "./sampleResume.json";

// A fully-populated resume used to render the template thumbnails and previews
// while the real tailored resume is generated in the background.
export const SAMPLE_RESUME = sample as unknown as TailoredResume;
